import React from "react"
import { Link } from "react-router-dom"
import styles from "../../../styles/Listing.module.css"

const LinkColumn = ({ value, to, itemId, text, userCtx, navigate }) => {
  return (
    <Link
      to={to}
      onClick={(e) => {
        e.preventDefault()
        userCtx.changeOrganization(itemId).then(() => {
          navigate(to)
        })
      }}
      className={styles.links}
    >
      {text}
    </Link>
  )
}

export default LinkColumn
